import React, { FC } from 'react';
import { IConfig } from '../../types/config';
import { IArticle } from '../../types/article';

import { IArticlesSponsored1 } from './ArticlesSponsored_1/params';
import { IArticlesSponsored2 } from './ArticlesSponsored_2/params';
import { IArticlesSponsored3 } from './ArticlesSponsored_3/params';
import { IArticlesSponsored4 } from './ArticlesSponsored_4/params';
import { IArticlesSponsored5 } from './ArticlesSponsored_5/params';
import { IArticlesSponsored6 } from './ArticlesSponsored_6/params';
import { IArticlesSponsored7 } from './ArticlesSponsored_7/params';
import { IArticlesSponsored8 } from './ArticlesSponsored_8/params';
import { IArticlesSponsored9 } from './ArticlesSponsored_9/params';

import ArticlesSponsored1 from './ArticlesSponsored_1';
import ArticlesSponsored2 from './ArticlesSponsored_2';
import ArticlesSponsored3 from './ArticlesSponsored_3';
import ArticlesSponsored4 from './ArticlesSponsored_4';
import ArticlesSponsored5 from './ArticlesSponsored_5';
import ArticlesSponsored6 from './ArticlesSponsored_6';
import ArticlesSponsored7 from './ArticlesSponsored_7';
import ArticlesSponsored8 from './ArticlesSponsored_8';
import ArticlesSponsored9 from './ArticlesSponsored_9';

const ArticlesSponsored: FC<{ config: IConfig; articles: IArticle[]; language: string }> = ({
  config,
  articles,
  language,
}) => {
  switch (config.home.articlesSponsored.variant) {
    case 9:
    case '9':
      return (
        <ArticlesSponsored9
          language={language}
          config={config.home.articlesSponsored.params as IArticlesSponsored9}
          articles={articles}
        />
      );
    case 8:
    case '8':
      return (
        <ArticlesSponsored8
          language={language}
          config={config.home.articlesSponsored.params as IArticlesSponsored8}
          articles={articles}
        />
      );
    case 7:
    case '7':
      return (
        <ArticlesSponsored7
          language={language}
          config={config.home.articlesSponsored.params as IArticlesSponsored7}
          articles={articles}
        />
      );
    case 6:
    case '6':
      return (
        <ArticlesSponsored6
          language={language}
          config={config.home.articlesSponsored.params as IArticlesSponsored6}
          articles={articles}
        />
      );
    case 5:
    case '5':
      return (
        <ArticlesSponsored5
          language={language}
          config={config.home.articlesSponsored.params as IArticlesSponsored5}
          articles={articles}
        />
      );
    case 4:
    case '4':
      return (
        <ArticlesSponsored4
          language={language}
          config={config.home.articlesSponsored.params as IArticlesSponsored4}
          articles={articles}
        />
      );
    case 3:
    case '3':
      return (
        <ArticlesSponsored3
          language={language}
          config={config.home.articlesSponsored.params as IArticlesSponsored3}
          articles={articles}
        />
      );
    case 2:
    case '2':
      return (
        <ArticlesSponsored2
          language={language}
          config={config.home.articlesSponsored.params as IArticlesSponsored2}
          articles={articles}
        />
      );
    default:
      return (
        <ArticlesSponsored1
          language={language}
          config={config.home.articlesSponsored.params as IArticlesSponsored1}
          articles={articles}
        />
      );
  }
};

export default ArticlesSponsored;
